// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2OwSA","validationTips":"StatementDescriptor_validationTips__2x5SO"};